













import Vue from "vue";
import { colorizer } from "./colorizer";
export default Vue.extend({
  computed: {
    percentReturn: {
      set(inp: number) {
        this.$store.commit("sliderSet", inp);
      },
      get(): number {
        return this.$store.state.sliderPercent;
      },
    },
  },

  methods: {
    newLog() {
      this.$store.commit(
        "appBack",
        colorizer(this.$store.state.defaultApp, this.$store.state.sliderPercent)
      );
    },
  },
});
